import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import 'izitoast/dist/css/iziToast.min.css';
import { GlobalErrorBoundary } from './components/GlobalErrorBoundary';
import './utils/legacyGlobalStubs';
import { validateAndWarnEnv } from './utils/envValidation';
// {|INICIO| 09/04/2026 às 12:20 - INTEGRAÇÃO GTM: BOOTSTRAP CONDICIONAL POR FLAG}
import { carregarGtmSeHabilitado } from './utils/gtm';
// {|FIM| 09/04/2026 às 12:20 - INTEGRAÇÃO GTM: BOOTSTRAP CONDICIONAL POR FLAG}

// Function-level comment: Valida variáveis de ambiente logo na inicialização da aplicação
// para avisar rapidamente sobre configurações ausentes ou inválidas.
validateAndWarnEnv();

// {|INICIO| 09/04/2026 às 12:20 - INTEGRAÇÃO GTM: CARREGAR APENAS QUANDO HABILITADO}
// Function-level comment: Inicializa o GTM o mais cedo possível no bootstrap do app
// para garantir que o dataLayer exista antes de eventos de conversão.
carregarGtmSeHabilitado();
// {|FIM| 09/04/2026 às 12:20 - INTEGRAÇÃO GTM: CARREGAR APENAS QUANDO HABILITADO}

// Expose version for debugging
console.log('%c KGV Reserva Online v2026-03-09 (Z-Index + Logs) ', 'background: #222; color: #bada55; padding: 4px; border-radius: 4px;');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </StrictMode>
);
